import {mountVueComponent} from '@/utils/mount';

function clearModals() {
    document.querySelectorAll('[id^="book-online-modal-"]').forEach((container) => {
        container._vueApp?.unmount();
        container.remove();
    });
}

function openBookOnline(trigger) {
    clearModals();

    const containerId = `book-online-modal-${Date.now()}`;
    const container = document.createElement('div');
    container.id = containerId;
    document.body.appendChild(container);

    const searchRoot = document.getElementById('search-band');
    const limits = JSON.parse(searchRoot?.dataset.props || '{}').limits || {};

    mountVueComponent(containerId, 'BookSearch', {
        destinationId: trigger.getAttribute('data-destination-id') || '',
        destinationName: trigger.getAttribute('data-destination-name') || '',
        departureDate: trigger.getAttribute('data-departure-date') || '',
        duration: Number.parseInt(trigger.getAttribute('data-duration') || '7', 10),
        adults: Number.parseInt(trigger.getAttribute('data-adults') || '2', 10),
        children: Number.parseInt(trigger.getAttribute('data-children') || '0', 10),
        containerId,
        limits,
    });
}

document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('.book-online') : null;
    if (!trigger) {
        return;
    }
    event.preventDefault();
    openBookOnline(trigger);
});
